var path = 'src/app/account/change-email/change-email.html';
var html = "<div page-wrapper> <h1 class=page-header>Change Email</h1> <p>Change your RaDaR email address.</p> <div change-email-component user=user></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/account/change-email/change-email.html
 ** module id = 16
 ** module chunks = 0
 **/